import React from 'react';
import RowButton from './RowButton';
import { useLocale } from './../special/LanguageProvider';


const RowChangeButton = ( { link = null, onClick = null }) => {
  const {t} = useLocale();
  return (
      <RowButton link={link} tooltip={t("Breyta")} iconclass={"icon-pencil4 no-text"} onClick={onClick} />
  );
}


export default RowChangeButton;